import React, { useCallback, useMemo, useState } from "react";
import Link from "next/link";
import { IconButton, Tooltip } from "@material-ui/core";
import { Edit as EditIcon } from "@material-ui/icons";
import { ActiveStatus } from "src/apps/commons/dataDisplays";
import { DataTable } from "src/apps/commons/dataTable";
import { ImageAvatar } from "src/apps/commons/fileUploads";
import { ListPaper } from "src/apps/commons/papers";
import { formatDateTime } from "src/utils";
import * as Api from "../api";
import {
  IRemyndBrand,
  IRemyndBrandPaginateReq,
  RemyndBrandFilterTypes,
  RemyndBrandPaginateOptionKey
} from "../types";
import { constants, paths } from "../utils";
import ListFilterPanel from "./ListFilterPanel";

const ListContainers: React.FC<unknown> = _ => {
  const [filters, setFilters] = useState<RemyndBrandFilterTypes>({});

  const itemToString = useCallback(
    (data: IRemyndBrand) => `${data.nameTh}`,
    []
  );

  const ManageCell = useCallback(
    (data: IRemyndBrand, isLoading: boolean) => (
      <div>
        {isLoading ? (
          <IconButton
            aria-label="Edit"
            key={`loading_manage_${data.id}`}
            disabled
          >
            <EditIcon />
          </IconButton>
        ) : (
          <Link href={`${paths.edit}?id=${data.id}`} key={`manage_${data.id}`}>
            <a>
              <IconButton aria-label="Edit">
                <Tooltip title={`แก้ไข${constants.label}`} placement="top">
                  <EditIcon />
                </Tooltip>
              </IconButton>
            </a>
          </Link>
        )}
      </div>
    ),
    []
  );
  const ActiveCell = useCallback(
    (data: IRemyndBrand) => <ActiveStatus value={data.active} />,
    []
  );
  const ImageCell = useCallback((data: IRemyndBrand) => {
    return data.imageId ? (
      <ImageAvatar fileId={data.imageId} fit="contain" />
    ) : (
      <div />
    );
  }, []);

  const defaultCriteria = useMemo(
    () =>
      ({
        paginate: {
          page: 1,
          pageSize: 10,
          order: { optionKey: "UPDATED_AT", desc: true }
        }
      } as IRemyndBrandPaginateReq),
    []
  );

  return (
    <>
      <ListFilterPanel onSubmit={v => setFilters(v)} />
      <ListPaper>
        <DataTable<
          IRemyndBrand,
          IRemyndBrandPaginateReq,
          RemyndBrandPaginateOptionKey,
          "MANAGE" | "IMAGE"
        >
          pathCreate={paths.create}
          searchTermLabel={"ค้นหาจาก ชื่อ (TH/EN)"}
          listEntity={Api.list}
          deleteEntities={Api.deleteMultiple}
          itemToString={itemToString}
          defaultCriteria={defaultCriteria}
          filterValues={filters}
          columns={[
            {
              id: "MANAGE",
              label: "จัดการ",
              width: 60,
              style: { paddingLeft: 0, paddingRight: 8 },
              align: "center",
              renderCell: ManageCell
            },
            {
              id: "IMAGE",
              label: "รูป",
              width: 80,
              align: "center",
              renderCell: ImageCell
            },
            {
              id: "NAME_TH",
              label: "ชื่อ (TH)",
              minWidth: 250,
              orderable: true,
              renderCell: data => data.nameTh
            },
            {
              id: "NAME_EN",
              label: "ชื่อ (EN)",
              minWidth: 250,
              orderable: true,
              renderCell: data => data.nameEn
            },
            {
              id: "CONTACT_COUNT",
              label: "จำนวน Contact",
              minWidth: 80,
              orderable: true,
              align: "right",
              renderCell: data => data.contactCount.toString()
            },
            {
              id: "ACTIVE",
              label: "Active",
              width: 80,
              orderable: true,
              align: "center",
              renderCell: ActiveCell
            },
            {
              id: "CREATED_AT",
              label: "สร้างเมื่อ",
              width: 200,
              orderable: true,
              renderCell: data => formatDateTime(data.createdAt)
            },
            {
              id: "UPDATED_AT",
              label: "แก้ไขล่าสุดเมื่อ",
              width: 200,
              orderable: true,
              renderCell: data => formatDateTime(data.updatedAt)
            }
          ]}
        />
      </ListPaper>
    </>
  );
};

export default ListContainers;
